// Angular
import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private errorMessageSignal = signal<string | null>(null);
    public readonly errorMessage = this.errorMessageSignal.asReadonly();

    /**
     * Shows an error message by setting the signal's value.
     * @param message The error message to display.
     */
    showError(message: string): void {
        this.errorMessageSignal.set(message);
    }

    /**
     * Hides the error message by setting the signal's value to null.
     * @memberof NotificationService
     */
    hideError(): void {
        this.errorMessageSignal.set(null);
    }
}